const SENSITIVE_HEADER_RE =
  /(authorization|cookie|x-api-key|x-auth-token|x-csrf-token|x-session-token)/i;
const SENSITIVE_KEY_RE =
  /(token|password|secret|api[-_]?key|authorization|cookie)/i;
const FILTERED = "[Filtered]";

export function scrubHeaders(
  headers: Record<string, string> | undefined,
): Record<string, string> | undefined {
  if (!headers) return headers;
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(headers)) {
    out[k] = SENSITIVE_HEADER_RE.test(k) ? FILTERED : v;
  }
  return out;
}

export function scrubObject(value: unknown): unknown {
  return walk(value, new WeakSet());
}

function walk(value: unknown, seen: WeakSet<object>): unknown {
  if (value === null || typeof value !== "object") return value;
  if (seen.has(value as object)) return "[Circular]";
  seen.add(value as object);
  if (Array.isArray(value)) return value.map((v) => walk(v, seen));
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
    out[k] = SENSITIVE_KEY_RE.test(k) ? FILTERED : walk(v, seen);
  }
  return out;
}

export function parseRate(value: string | undefined, fallback: number): number {
  if (!value) return fallback;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0 || n > 1) return fallback;
  return n;
}
